import { CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, NgModule, forwardRef } from '@angular/core';

import { CommonModule } from '@angular/common';
import { ActionsButtonsComponent } from '../system-utils/actions-buttons/actions-buttons.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatCardModule } from '@angular/material/card';
import { MatTabsModule } from '@angular/material/tabs';
import { MatButtonModule } from '@angular/material/button';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { SidePanelComponent } from '../system-utils/side-panel/side-panel.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CustomLoadingOverlay, QueryExecutorComponent, QueryExecutorPopupDialog } from '../forms/query-executor/query-executor.component';
import { MatDividerModule } from '@angular/material/divider';
import DragDirective from '../system-utils/utils/directives/draggable-directive';
import { AngularSplitModule } from 'angular-split';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { ArrayFilter } from '../system-utils/pipes/filter';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { ModuleRegistry } from '@ag-grid-community/core';
import { CsvExportModule } from "@ag-grid-community/csv-export";
import { AgGridModule } from "@ag-grid-community/angular"
import {ClientSideRowModelModule} from "@ag-grid-community/client-side-row-model";
import { GenericIconComponent } from '../system-utils/generic-icon/generic-icon.component';
import { IconServices } from '../services/icon.services';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { BrowserModule } from '@angular/platform-browser';
import { MatNativeDateModule, MatOptionModule } from '@angular/material/core';
import { MatSliderModule } from '@angular/material/slider';
import { ExpansePanelComponent } from '../system-utils/expanse-panel/expanse-panel.component';
import { FormArrayComponentComponent } from '../system-utils/form-array-component/form-array-component.component';
import { MatChipsModule } from '@angular/material/chips';
import { MatAnimatedIconComponent } from '../system-utils/mat-animated-icon/mat-animated-icon.component';
import { MatBadgeModule } from '@angular/material/badge';
import { SuspendedMenuComponent } from '../system-utils/suspended-menu/suspended-menu.component';
import { MatGridListModule } from '@angular/material/grid-list';
import { SearchFieldService } from '../services/search-filed.service';
import {TranslateModule, TranslateLoader, TranslateService, TranslateStore, TranslatePipe} from '@ngx-translate/core';


import { CdkStepperModule } from '@angular/cdk/stepper';
import { SidePanelStepComponent, SidePanelStepperComponent } from "../system-utils/side-panel-stepper/side-panel-stepper.component";
import { TreeviewModule } from '@soy-andrey-semyonov/ngx-treeview';
import { MatMenuModule } from '@angular/material/menu';
import { MatDialogModule } from '@angular/material/dialog';
import { QueryExecutorComponentSettings } from '../forms/query-executor/query-executor-settings/query-executor-settings.component';
import { FormItemComponentComponent } from '../system-utils/form-item-component/form-item-component.component';
import { FormViewDirective } from '../dynamic-forms/form-view/form-view.directive';
import { UpperDirective } from '../system-utils/utils/directives/uppercase-directive';
import { CustomMaskDirective } from '../system-utils/utils/directives/custom-mask-directive';
import { TooltipDirective } from '../system-utils/utils/directives/tooltip-directive';
import { NumericDirective } from '../system-utils/utils/directives/numeric.directive';
import { FormViewInputComponent } from '../dynamic-forms/form-view/form-view-input/form-view-input.component';
import { DynamicFormsComponent } from '../dynamic-forms/dynamic-forms.component';
import { FormViewDateComponent } from '../dynamic-forms/form-view/form-view-date/form-view-date.component';
import { FormViewImageComponent } from '../dynamic-forms/form-view/form-view-image/form-view-image.component';
import { FormViewNumberComponent } from '../dynamic-forms/form-view/form-view-number/form-view-number.component';
import { FormViewRichTextComponent } from '../dynamic-forms/form-view/form-view-rich-text/form-view-rich-text.component';
import { FormViewSearchComponent } from '../dynamic-forms/form-view/form-view-search/form-view-search.component';
import { FormViewSelectComponent } from '../dynamic-forms/form-view/form-view-select/form-view-select.component';
import { FormViewTextComponent } from '../dynamic-forms/form-view/form-view-text/form-view-text.component';
import { FormViewText2Component } from '../dynamic-forms/form-view/form-view-text2/form-view-text2.component';
import { FormViewComponent } from '../dynamic-forms/form-view/form-view.component';
import { ToolBarComponent } from '../dynamic-forms/tool-bar/tool-bar.component';
import { CopyFormConfigurationComponent } from '../forms/formview/copy-form-configuration/copy-form-configuration.component';
import { EditFormMultiTableComponent } from '../forms/formview/edit-form-multi-table/edit-form-multi-table.component';
import { EditFormComponent } from '../forms/formview/editform.component';
import { FormFieldPropertiesDetailActionsParamsComponent } from '../forms/formview/form-field-properties/form-field-properties-detail-actions-params/form-field-properties-detail-actions-params.component';
import { FormFieldPropertiesDetailActionsComponent } from '../forms/formview/form-field-properties/form-field-properties-detail-actions/form-field-properties-detail-actions.component';
import { FormFieldPropertiesDetailComponent } from '../forms/formview/form-field-properties/form-field-properties-detail/form-field-properties-detail.component';
import { FormFieldPropertiesComponent } from '../forms/formview/form-field-properties/form-field-properties.component';
import { FormConfigurationTabSelectComponent } from '../forms/gridview/filterview/form-configuration/form-configuration-tab-select/form-configuration-tab-select.component';
import { FormConfigurationComponent } from '../forms/gridview/filterview/form-configuration/form-configuration.component';
import { PromptFilterViewComponent } from '../forms/prompt-filter-view/prompt-filter-view.component';
import { CustomActionParametersComponent } from '../forms/simple-datagrid/custom-action-parameters/custom-action-parameters.component';
import { GridConfigDialogComponent } from '../forms/simple-datagrid/grid-config-dialog/grid-config-dialog.component';
import { SimpleDatagridComponent } from '../forms/simple-datagrid/simple-datagrid.component';
import { SimpleDatatreeComponent } from '../forms/simple-datatree/simple-datatree.component';
import { ComponentFactoryComponent } from '../system-utils/component-factory/component-factory-view.component';
import { GenericDatagridComponent } from '../system-utils/generic-datagrid/generic-datagrid.component';
import { GridSelectorComponent } from '../system-utils/grid-selector/grid-selector.component';
import { MessageDialogComponent } from '../system-utils/message-dialog/message-dialog.component';
import { Capitalize } from '../system-utils/pipes/capitalize';
import { SearchDialogComponent } from '../system-utils/search-dialog/search-dialog.component';
import { SearchInputComponent } from '../system-utils/search-input/search-input.component';
import { NgModelChangeDebouncedDirective } from '../system-utils/utils/directives/ngModelChangeDebounced-directive';
import { OnlyAlphaDirective } from '../system-utils/utils/directives/only-alpha.directive';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatStepperModule } from '@angular/material/stepper';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgxEditorModule } from 'ngx-editor';
import { IConfig, NgxMaskModule } from 'ngx-mask';
import { GridsterModule } from 'angular-gridster2';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTableModule } from '@angular/material/table';
import { MatRadioModule } from '@angular/material/radio';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { AdminServices } from '../services/AdminServices';
import { ControlEDirective } from '../system-utils/utils/directives/controE-directive';
import { FileLoaderComponent } from '../system-utils/file-loader/file-loader.component';
import { FileLoaderServices } from '../services/FileLoader.services';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { SearchOptionListComponent } from '../system-utils/search-option-list/search-option-list.component';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { CustomPaginatorIntl, LanguageServices } from '../services/LanguageServices';
import { ThemeService } from '../services/theme.service';
import { TranslateFormComponent } from '../forms/translate-form/translate-form.component';
import { MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { TranslateFormNewComponent } from '../forms/translate-form/translate-form-new/translate-form-new.component';
import { TranslateFormAiComponent } from '../forms/translate-form/translate-form-ai/translate-form-ai.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgxColorsModule } from 'ngx-colors';
import {ScrollingModule} from '@angular/cdk/scrolling';
import { JsonViewerComponent } from '../system-utils/json-viewer/json-viewer.component';
import { DynamicLoaderService } from '../services/dynamic-loader.service';
import { CodeEditorComponent } from '../system-utils/code-editor/code-editor.component';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzSplitterModule } from 'ng-zorro-antd/splitter';
import { SafePipe } from '../system-utils/pipes/safe';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzFloatButtonModule } from 'ng-zorro-antd/float-button';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { GenericLogComponent, GridButtonRendererComponent } from '../forms/generic-log/generic-log.component';
import { GenericLogSearchPipe } from '../forms/generic-log/generic-log-search.pipe';
import { TranslateTA } from '../system-utils/pipes/translateTA';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzStepsModule } from 'ng-zorro-antd/steps';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzTreeModule } from 'ng-zorro-antd/tree';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzProgressModule } from 'ng-zorro-antd/progress';
import { NzAutocompleteModule } from 'ng-zorro-antd/auto-complete';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { SearchInputNewComponent } from '../system-utils/search-input-new/search-input-new.component';
import { QuillModule } from 'ngx-quill'

ModuleRegistry.registerModules([
  CsvExportModule,
  ClientSideRowModelModule
]);

const maskConfig: Partial<IConfig> = {
    validation: false,
  };


@NgModule({
  declarations: [
    ActionsButtonsComponent,
    SidePanelComponent,
    ControlEDirective,
    CustomLoadingOverlay,
    QueryExecutorPopupDialog,
    QueryExecutorComponent,
    ArrayFilter,
    GenericIconComponent,
    ExpansePanelComponent,
    FormArrayComponentComponent,
    MatAnimatedIconComponent,
    SuspendedMenuComponent,
    DragDirective,
    SidePanelStepperComponent,
    SidePanelStepComponent,
    QueryExecutorComponentSettings,
    FormItemComponentComponent,
    FormViewDirective, 
    CustomMaskDirective,
    UpperDirective,
    TooltipDirective,
    NumericDirective, 
    FormViewInputComponent, 
    DynamicFormsComponent, 
    GridSelectorComponent, 
    FormViewComponent, 
    ToolBarComponent, 
    FormViewSelectComponent, 
    FormViewDateComponent,
    FormViewTextComponent, 
    FormViewText2Component, 
    FormViewNumberComponent, 
    MessageDialogComponent, 
    FormViewSearchComponent,  
    GenericDatagridComponent, 
    Capitalize, 
    FormViewImageComponent,
    SearchDialogComponent,
    FormViewRichTextComponent,
    FormFieldPropertiesComponent, 
    FormFieldPropertiesDetailComponent, 
    FormFieldPropertiesDetailActionsComponent, 
    NgModelChangeDebouncedDirective,
    FormFieldPropertiesDetailActionsParamsComponent,
    CustomActionParametersComponent,
    OnlyAlphaDirective,
    PromptFilterViewComponent,
    SearchInputComponent,
    EditFormComponent,
    SimpleDatagridComponent,
    ComponentFactoryComponent,
    GridConfigDialogComponent,
    SimpleDatatreeComponent,
    FormConfigurationComponent,
    FormConfigurationTabSelectComponent,
    CopyFormConfigurationComponent,
    EditFormMultiTableComponent,
    FileLoaderComponent,
    SearchOptionListComponent,
    TranslateFormComponent,
    TranslateFormNewComponent,
    TranslateFormAiComponent,
    JsonViewerComponent,
    CodeEditorComponent,
    SafePipe,
    GenericLogComponent,
    GenericLogSearchPipe,
    GridButtonRendererComponent,
    TranslateTA,
    SearchInputNewComponent
  ],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    MatOptionModule,
    MatBadgeModule,
    AgGridModule,
    GridsterModule,
    CommonModule,
    FlexLayoutModule,
    MatCardModule,
    MatTabsModule,
    MatButtonModule,
    DragDropModule,
    AngularSplitModule,
    MatDividerModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatToolbarModule,
    MatRadioModule,
    MatSelectModule,
    MatCheckboxModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatSlideToggleModule,
    MatSliderModule,
    ReactiveFormsModule,
    FormsModule,
    MatChipsModule,
    CdkStepperModule,
    MatGridListModule,
    MatListModule,
    TranslateModule,
    MatMenuModule,
    MatDialogModule,
    NgxDatatableModule,
    MatNativeDateModule,
    DragDropModule,
    ClipboardModule,
    TreeviewModule.forRoot(),
    AngularSplitModule,
    MatSnackBarModule,
    MatAutocompleteModule,
    MatTabsModule,
    MatGridListModule,
    MatDatepickerModule,
    MatMenuModule,
    MatStepperModule,
    NgxSpinnerModule,
    MatExpansionModule,
    MatTableModule,
    FontAwesomeModule,
    MatSortModule,
    MatPaginatorModule,
    ScrollingModule,
    QuillModule,
    NgxEditorModule.forRoot({
                locals: {
                    bold: 'Negrito',
                    italic: 'Itálico',
                    code: 'Código',
                    blockquote: 'Comentário',
                    underline: 'Sublinhado',
                    strike: 'Tachado',
                    bullet_list: 'Marcadores',
                    ordered_list: 'Numeração',
                    heading: 'Cabeçalho',
                    h1: 'Cabeçalho 1',
                    h2: 'Cabeçalho 2',
                    h3: 'Cabeçalho 3',
                    h4: 'Cabeçalho 4',
                    h5: 'Cabeçalho 5',
                    h6: 'Cabeçalho 6',
                    align_left: 'Alinhar à Esquerda',
                    align_center: 'Centralizar',
                    align_right: 'Alinhar à Direita',
                    align_justify: 'Justificar',
                    text_color: 'Cor da Fonte',
                    background_color: 'Cor do Fundo',
                    url: 'URL',
                    text: 'Texto',
                    insert: 'Inserir',
                    altText: 'Alt Texto',
                    title: 'Título',
                    remove: 'Remover',
                    insertLink: 'Inserir Link',
                    removeLink: 'Remover Link',
                    insertImage: 'Inserir Imagem'
                  
                }}),
        NgxMaskModule.forRoot(maskConfig),
        NgxMatSelectSearchModule,
        NgxColorsModule,
        NzButtonModule,
        NzIconModule,
        NzTooltipModule,
        NzDividerModule,
        NzSplitterModule,
        NzCardModule,
        NzSelectModule,
        NzInputModule,
        NzGridModule,
        NzTableModule,
        NzSwitchModule,
        NzDrawerModule,
        NzFloatButtonModule,
        NzDropDownModule,
        NzTooltipModule,
        NzDividerModule,
        NzPopoverModule,
        NzUploadModule,
        NzMenuModule,
        NzSpinModule,
        NzTabsModule,
        NzStepsModule,
        NzRadioModule,
        NzCollapseModule,
        NzCheckboxModule,
        NzTreeModule,
        NzDatePickerModule,
        NzProgressModule,
        NzAutocompleteModule,
        NzToolTipModule,
        MatProgressSpinnerModule
  ],

  schemas: [],
  providers:[
      IconServices,
      FileLoaderServices,
      SearchFieldService,
      TranslateService, 
      TranslateStore,
      AdminServices,
      LanguageServices,
      ThemeService,
      DynamicLoaderService,
      { provide: MatPaginatorIntl, useClass: CustomPaginatorIntl },
      

  ],
  exports:[
    SearchInputNewComponent,
    ActionsButtonsComponent,
    SidePanelComponent,
    QueryExecutorComponent,
    CustomLoadingOverlay,
    ArrayFilter,
    ControlEDirective,
    GenericIconComponent,
    ExpansePanelComponent,
    FormArrayComponentComponent,
    MatAnimatedIconComponent,
    SuspendedMenuComponent,
    TranslateModule,
    DragDirective,
    SidePanelStepperComponent,
    SidePanelStepComponent,
    QueryExecutorPopupDialog,
    QueryExecutorComponentSettings,
    FormItemComponentComponent,
    FormViewDirective, 
    CustomMaskDirective,
    UpperDirective,
    TooltipDirective,
    NumericDirective, 
    FormViewInputComponent, 
    DynamicFormsComponent, 
    GridSelectorComponent, 
    FormViewComponent, 
    ToolBarComponent, 
    FormViewSelectComponent, 
    FormViewDateComponent,
    FormViewTextComponent, 
    FormViewText2Component, 
    FormViewNumberComponent, 
    MessageDialogComponent, 
    FormViewSearchComponent,  
    GenericDatagridComponent, 
    Capitalize, 
    FormViewImageComponent,
    SearchDialogComponent,
    FormViewRichTextComponent,
    FormFieldPropertiesComponent, 
    FormFieldPropertiesDetailComponent, 
    FormFieldPropertiesDetailActionsComponent, 
    NgModelChangeDebouncedDirective,
    FormFieldPropertiesDetailActionsParamsComponent,
    CustomActionParametersComponent,
    OnlyAlphaDirective,
    PromptFilterViewComponent,
    SearchInputComponent,
    EditFormComponent,
    SimpleDatagridComponent,
    ComponentFactoryComponent,
    GridConfigDialogComponent,
    SimpleDatatreeComponent,
    FormConfigurationComponent,
    FormConfigurationTabSelectComponent,
    CopyFormConfigurationComponent,
    EditFormMultiTableComponent,
    SearchOptionListComponent,
    NgxSpinnerModule,
    TranslateFormComponent,
    JsonViewerComponent,
    QueryExecutorComponent,
    SafePipe,
    CodeEditorComponent,
    GenericLogComponent,
    GenericLogSearchPipe,
    GridButtonRendererComponent,
    NzButtonModule,
    NzIconModule,
    NzTooltipModule,
    NzDividerModule,
    NzSplitterModule,
    NzCardModule,
    NzSelectModule,
    NzInputModule,
    NzGridModule,
    NzTableModule,
    NzSwitchModule,
    NzDrawerModule,
    NzFloatButtonModule,
    NzDropDownModule,
    NzTooltipModule,
    NzDividerModule,
    NzPopoverModule,
    TranslateTA,
    NzUploadModule,
    NzMenuModule,
    NzSpinModule,
    NzTabsModule,
    NzStepsModule,
    NzRadioModule,
    NzCollapseModule,
    NzCheckboxModule,
    NzTreeModule,
    NzDatePickerModule,
    NzProgressModule,
    NzAutocompleteModule,
    NzToolTipModule,
    MatProgressSpinnerModule,
    QuillModule
   ]
})
export class SharedModule { }
